import React from 'react'
import type { HealthStatus } from '@/types/status'
import { StatusDot } from '@/components/data-display/StatusDot'
import { StaleBadge } from '@/components/feedback/StaleBadge'
import type { FreshnessState } from '@/types/status'

interface SurfaceCardProps {
  title?: string
  children: React.ReactNode
  footer?: React.ReactNode
  status?: HealthStatus
  freshness?: FreshnessState
  className?: string
  headerActions?: React.ReactNode
}

export function SurfaceCard({
  title,
  children,
  footer,
  status,
  freshness,
  className = '',
  headerActions,
}: SurfaceCardProps) {
  return (
    <div
      className={`surface p-0 flex flex-col ${className}`}
      style={{ transition: 'border-color var(--transition-hover)' }}
    >
      {title && (
        <div className="flex items-center justify-between px-5 py-3 border-b border-border">
          <div className="flex items-center gap-2">
            <h3 className="text-subheading text-text">{title}</h3>
            {status && <StatusDot status={status} />}
          </div>
          <div className="flex items-center gap-2">
            {freshness && freshness !== 'fresh' && <StaleBadge freshness={freshness} />}
            {headerActions}
          </div>
        </div>
      )}
      <div className="flex-1 p-5">{children}</div>
      {footer && (
        <div className="px-5 py-3 border-t border-border text-tiny text-text-dim">
          {footer}
        </div>
      )}
    </div>
  )
}
